(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mobile menu ---------- */
  var hd = document.getElementById('hd');
  var bg = document.getElementById('burger');
  if(hd && bg){
    bg.addEventListener('click', function(){
      var o = hd.classList.toggle('open');
      bg.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
    document.querySelectorAll('nav.main a').forEach(function(a){
      a.addEventListener('click', function(){ hd.classList.remove('open'); });
    });
  }

  /* ---------- count up ---------- */
  function count(el){
    var t = parseFloat(el.dataset.c);
    if(isNaN(t)) return;
    var p = el.dataset.p || '', s = el.dataset.s || '';
    if(reduce){ el.textContent = p + t + s; return; }
    var dur = 1400, t0 = performance.now();
    function step(now){
      var k = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      var v = t >= 1000 ? Math.round(t * e / 10) * 10 : Math.round(t * e);
      el.textContent = p + v + s;
      if(k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- reveal on scroll ---------- */
  var items = document.querySelectorAll('.rv');
  if(items.length){
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){
        el.classList.add('in');
        el.querySelectorAll('[data-c]').forEach(count);
      });
    } else {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return;
          e.target.classList.add('in');
          e.target.querySelectorAll('[data-c]').forEach(count);
          io.unobserve(e.target);
        });
      }, {threshold:.18, rootMargin:'0px 0px -6% 0px'});
      items.forEach(function(el){ io.observe(el); });
    }
  }

  /* ---------- hero telemetry flicker ---------- */
  var t1 = document.getElementById('t1');
  if(t1 && !reduce){
    var t2 = document.getElementById('t2'), t3 = document.getElementById('t3');
    var kmh = 160;
    setInterval(function(){
      /* vitesse voiture : marche aleatoire douce entre 80 et 300 km/h */
      kmh += (Math.random() - 0.45) * 34;
      kmh = Math.max(80, Math.min(300, kmh));
      /* le ventilateur suit la vitesse : 800 tr/min au ralenti, 8000 a fond */
      var rpm = Math.round((800 + (kmh / 300) * 7200) / 50) * 50;
      t1.textContent = Math.round(kmh) + ' km/h';
      if(t2) t2.textContent = rpm + ' tr/min';
      if(t3) t3.textContent = (9 + Math.floor(Math.random() * 9)) + ' ms';
    }, 1500);
  }

  /* ---------- iFlag switcher ---------- */
  var flagMedia = document.querySelector('.flag-media');
  if(flagMedia){
    var cols = {green:'#2fd94a', yellow:'#ffd21f', blue:'#39a5ff'};
    var labs = {green:'Signal · drapeau vert', yellow:'Signal · drapeau jaune', blue:'Signal · drapeau bleu'};
    var imgs = flagMedia.querySelectorAll('img');
    var chips = document.querySelectorAll('.chip');
    var glow = document.getElementById('glow');
    var cap = document.getElementById('fcap');
    var panel = flagMedia.closest('section');
    var order = ['green','yellow','blue'], i = 0, auto = true;

    function set(f){
      imgs.forEach(function(x){ x.classList.toggle('on', x.dataset.f === f); });
      chips.forEach(function(x){ x.classList.toggle('on', x.dataset.f === f); });
      if(glow) glow.style.setProperty('--flag', cols[f] || '#3ae7ff');
      if(cap) cap.textContent = labs[f] || '';
    }
    chips.forEach(function(c){
      c.addEventListener('click', function(){ auto = false; set(c.dataset.f); });
    });
    if(!reduce){
      setInterval(function(){
        if(!auto || !panel) return;
        var r = panel.getBoundingClientRect();
        if(r.bottom < 0 || r.top > window.innerHeight) return;
        i = (i + 1) % order.length;
        set(order[i]);
      }, 2800);
    }
  }

  /* ---------- product gallery ---------- */
  var main = document.getElementById('pdpMain');
  if(main){
    document.querySelectorAll('.thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        if(b.dataset.full) main.src = b.dataset.full;
        document.querySelectorAll('.thumbs button').forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  }

  /* ==================================================
     MOTEUR DE DÉFILEMENT (effets style apple.com)
     ================================================== */
  (function(){
    if(reduce) return;

    var stage   = document.querySelector('.stage-frame .stage');
    var heroCopy= document.querySelector('.hero-copy');
    var pars    = document.querySelectorAll('[data-par]');
    var stWords = [];
    var pinSec  = document.querySelector('.pin-sec');
    var pinSteps= document.querySelectorAll('.pin-step');
    var pinImgs = document.querySelectorAll('.pin-media img');
    var pinIdx  = -1;

    /* découpe la grande phrase en mots */
    var st = document.querySelector('.statement h2');
    if(st && !st.dataset.split){
      st.dataset.split = 1;
      (function walk(node){
        Array.prototype.slice.call(node.childNodes).forEach(function(n){
          if(n.nodeType === 3){
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function(p){
              if(!p) return;
              if(/^\s+$/.test(p)){ frag.appendChild(document.createTextNode(p)); return; }
              var s = document.createElement('span');
              s.className = 'sw';
              if(node.tagName === 'EM') s.classList.add('accent');
              s.textContent = p;
              frag.appendChild(s); stWords.push(s);
            });
            n.parentNode.replaceChild(frag, n);
          } else if(n.nodeType === 1) walk(n);
        });
      })(st);
    }

    function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }

    var ticking = false;
    function frame(){
      var vh = window.innerHeight;

      /* 1. élargissement du visuel du hero */
      if(stage){
        var r = stage.getBoundingClientRect();
        /* progresse pendant que le bloc remonte vers le haut de l'écran */
        var p = clamp((vh - r.top) / (vh * 0.85));
        stage.style.setProperty('--p', p.toFixed(4));
      }

      /* 2. le texte du hero s'efface en montant */
      if(heroCopy){
        var hr = heroCopy.getBoundingClientRect();
        var hp = clamp((-hr.top) / (vh * 0.5));
        heroCopy.style.opacity = (1 - hp * 0.9).toFixed(3);
        heroCopy.style.transform = 'translate3d(0,' + (hp * -40).toFixed(1) + 'px,0)';
      }

      /* 3. parallaxe */
      pars.forEach(function(el){
        var b = el.getBoundingClientRect();
        if(b.bottom < 0 || b.top > vh) return;
        var c = (b.top + b.height / 2 - vh / 2) / vh;
        var img = el.querySelector('img');
        if(img) img.style.setProperty('--py', (c * -34).toFixed(1) + 'px');
      });

      /* 4. mots de la grande phrase */
      if(stWords.length){
        var sr = st.getBoundingClientRect();
        var sp = clamp((vh * 0.78 - sr.top) / (sr.height + vh * 0.3));
        var n = Math.floor(sp * stWords.length * 1.3);
        for(var i = 0; i < stWords.length; i++){
          stWords[i].classList.toggle('lit', i < n);
        }
      }

      /* 5. scene epinglee : un seul bloc visible, choisi par la progression */
      if(pinSec && pinSteps.length){
        var pr = pinSec.getBoundingClientRect();
        var span = pinSec.offsetHeight - vh;
        var pp = span > 0 ? clamp(-pr.top / span) : 0;
        var idx = Math.round(pp * (pinSteps.length - 1));
        if(idx !== pinIdx){
          pinIdx = idx;
          pinSteps.forEach(function(s, i){ s.classList.toggle('on', i === idx); });
          pinImgs.forEach(function(im, i){ im.classList.toggle('on', i === idx); });
          pinSteps.forEach(function(s){
            var dots = s.querySelectorAll('.pin-dots i');
            dots.forEach(function(d, i){ d.classList.toggle('on', i === idx); });
          });
        }
      }

      ticking = false;
    }

    window.addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(frame); ticking = true; }
    }, {passive:true});
    window.addEventListener('resize', frame, {passive:true});
    frame();

    /* ------------------------------------------------------------
       Accroche bloc par bloc, limitee a la scene epinglee.
       Elle n'agit qu'une fois le defilement arrete, et seulement
       si la section occupe l'ecran : le reste de la page defile
       librement.
       ------------------------------------------------------------ */
    if(pinSec && pinSteps.length > 1){
      var snapT = null, snapping = false;

      function settle(){
        if(snapping) return;
        var vh2 = window.innerHeight;
        var r = pinSec.getBoundingClientRect();

        /* la scene doit remplir l'ecran, sinon on ne touche a rien */
        if(r.top > vh2 * 0.2 || r.bottom < vh2 * 1.2) return;

        var span = pinSec.offsetHeight - vh2;
        if(span <= 0) return;
        var top = window.scrollY + r.top;
        var stepH = span / (pinSteps.length - 1);
        var target = top + Math.round((window.scrollY - top) / stepH) * stepH;

        /* deja en place : on s'abstient */
        if(Math.abs(target - window.scrollY) < 3) return;

        snapping = true;
        window.scrollTo({top: target, behavior: 'smooth'});
        setTimeout(function(){ snapping = false; }, 700);
      }

      window.addEventListener('scroll', function(){
        clearTimeout(snapT);
        snapT = setTimeout(settle, 140);
      }, {passive:true});

      /* une interaction directe annule l'accroche en cours */
      ['wheel','touchstart','keydown'].forEach(function(ev){
        window.addEventListener(ev, function(){
          snapping = false;
          clearTimeout(snapT);
        }, {passive:true});
      });
    }
  })();

  /* ---------- barre d'achat fixe (mobile) ---------- */
  var buybar = document.getElementById('buybar');
  var pform = document.getElementById('ProductForm');
  if(buybar && pform){
    var addBtn = pform.querySelector('button[name="add"]');
    var btn = document.getElementById('buybarBtn');

    if(btn && addBtn){
      btn.addEventListener('click', function(){
        pform.requestSubmit ? pform.requestSubmit(addBtn) : pform.submit();
      });
    }

    /* le prix de la barre suit la variante sélectionnée */
    var sel = document.getElementById('VariantSelect');
    var priceEl = buybar.querySelector('.buybar-info span');
    var mainPrice = document.querySelector('.pdp-price span:last-child');
    if(sel && priceEl){
      sel.addEventListener('change', function(){
        var o = sel.options[sel.selectedIndex];
        if(!o) return;
        if(o.dataset.price){
          priceEl.textContent = o.dataset.price;
          if(mainPrice) mainPrice.textContent = o.dataset.price;
        }
        var avail = o.dataset.available === 'true';
        if(btn){ btn.disabled = !avail; btn.textContent = avail ? 'Ajouter' : 'Épuisé'; }
        if(addBtn){ addBtn.disabled = !avail; addBtn.textContent = avail ? 'Ajouter au panier' : 'Épuisé'; }
      });
    }

    /* n'apparaît que lorsque le bouton principal est sorti de l'écran */
    if('IntersectionObserver' in window && addBtn){
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          buybar.classList.toggle('show', !e.isIntersecting);
          buybar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
        });
      }, {threshold:0}).observe(addBtn);
    }
  }

  /* ---------- cart qty auto update ---------- */
  document.querySelectorAll('.cart-qty').forEach(function(input){
    input.addEventListener('change', function(){
      var f = input.closest('form');
      if(f){ f.requestSubmit ? f.requestSubmit() : f.submit(); }
    });
  });
})();
